import home from "./home";
import about from "./about";
import contact from "./contact";
import machine from "./machine";
import software from "./software";
import print from "./print";
import faq from "./faq";

const data = {
  home,
  about,
  contact,
  machine,
  software,
  print,
  faq,
};

export default data;
